// Create Reimbursement
export const CREATE_REIMBURSEMENT_REQUEST = 'CREATE_REIMBURSEMENT_REQUEST';
export const CREATE_REIMBURSEMENT_DONE = 'CREATE_REIMBURSEMENT_DONE';
export const CREATE_REIMBURSEMENT_FAILED = 'CREATE_REIMBURSEMENT_FAILED';
export const CREATE_REIMBURSEMENT_RESET = 'CREATE_REIMBURSEMENT_RESET';